import React, { useEffect, useState } from "react";
import { fetchAndStoreUserPermissions } from "../../service/AuthService";
import { getStoredAccessToken, isAuthenticated } from "../../utils/authSession";

const PermissionBootstrap = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      if (!isAuthenticated()) {
        if (!cancelled) setReady(true);
        return;
      }

      const token = getStoredAccessToken();
      if (!token) {
        if (!cancelled) setReady(true);
        return;
      }

      try {
        await fetchAndStoreUserPermissions(token);
      } catch {
        // Fall back to cached permissions when refresh fails.
      } finally {
        if (!cancelled) setReady(true);
      }
    };

    bootstrap();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-[#2B7FFF]" />
      </div>
    );
  }

  return children;
};

export default PermissionBootstrap;
